import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { name: "pantry-camera-check-select-view" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PantryCameraCheckView = _resolveComponent("PantryCameraCheckView")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.getFoodList(), (item, index) => {
      return (_openBlock(), _createBlock(_component_PantryCameraCheckView, {
        key: index,
        id: index,
        food: item,
        selectPosition: _ctx.selectPosition,
        update: _ctx.update,
        isFoodTimerExec: _ctx.isFoodTimerExec,
        onClickFood: _ctx.onClickFood,
        onClickInput: _ctx.onClickInput,
        onSelectImage: _ctx.selectImage,
        onStatus: _ctx.onStatus
      }, null, 8, ["id", "food", "selectPosition", "update", "isFoodTimerExec", "onClickFood", "onClickInput", "onSelectImage", "onStatus"]))
    }), 128 /* KEYED_FRAGMENT */))
  ]))
}